import { Fragment } from 'react';
import './index.css';

export const ANDROID_APK = "https://arcus-mdh-bff-mobile-api.cencosudx.com/files?name=bc20e97e-9074-412a-84a7-e24f63a31ea5&path=milocal%2Fmdh%2Fproduction%2F1.23.1%2F226c9ab5b153853296be562e0023aa2ed89d2eb5%2Fandroid%2Fd2fee8dd9280042fa4d43e7bed8fc343595e045ba42f050a1373337fb1cd5bd9&file_name=milocal-1.23.1-base-1.23.1-production-mdh-android-226c9ab-472.apk";
export const PDA_APK = "https://arcus-mdh-bff-mobile-api.cencosudx.com/files?name=433aeafd-6cbe-46cb-ac55-7fd20d8ac68e&path=milocal%2Fmdh%2Fproduction%2F1.23.1%2F226c9ab5b153853296be562e0023aa2ed89d2eb5%2Fpda%2F1573f47e66fa26c3afb431afa061d5a3ef5aa3ac98c5ea8fdb64c7d661b8d90c&file_name=milocal-1.23.1-base-1.23.1-production-mdh-pda-226c9ab-472.apk";

function AndroidPage({ apkUrl = ANDROID_APK }: { apkUrl?: string }) {
    return <Fragment >
        <div className="android-page">
            <div className="content">
                <img src="assets/img/android/1.png" alt="" />
                <a className='btndownload' href={apkUrl} target="_self">
                    <img src="assets/img/android/2.png" alt="" />
                </a>
                <img className='mb-2 card' src="assets/img/android/3.png" alt="" />
                <img className='mb-2 card' src="assets/img/android/4.png" alt="" />
                <img className='mb-2 card' src="assets/img/android/5.png" alt="" />
                <img className='mb-2' src="assets/img/android/6.png" alt="" />
            </div>
        </div>

    </Fragment>

}

export default AndroidPage;
